import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { LINKS } from '../../../../constants';

const TeamLink = ({ team }) => (
    <Link to={`/${LINKS.TEAMS}/${team.link}`} className="nav-link">
        {team.title}
    </Link>
);

TeamLink.propTypes = {
    team: PropTypes.shape({
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        link: PropTypes.string,
    }),
};

export default TeamLink;
